// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Id-z","image":"Jd-z","imageNoBackground":"Kd-z"};